import { environmentCommon } from '../../../environments/environment-common';
import { URLS } from '../navigation/navigation.data';

export const COMPANY_PAGES: { name: string, url: string, isExternal?: boolean }[] = [
  {
    name: 'Blog',
    url: URLS.blog
  },
  {
    name: 'Contact Us',
    url: URLS.contactUs
  },
  {
    name: 'Jobs',
    url: environmentCommon.website.linkedin.companyUrl + '/' + environmentCommon.company.social.linkedin + '/jobs',
    isExternal: true
  },
  {
    name: 'Open Source',
    url: environmentCommon.website.github.url + '/' + environmentCommon.company.social.github,
    isExternal: true
  },
];

export const RESOURCES_PAGES: { name: string, url: string, isExternal?: boolean }[] = [
  {
    name: 'Color Palettes',
    url: URLS.palettes
  },
  {
    name: 'Branding',
    url: URLS.branding
  },
  {
    name: 'Terms And Conditions',
    url: URLS.terms
  },
  {
    name: 'Terms of Sale',
    url: URLS.storeTerms
  },
  {
    name: 'Privacy',
    url: URLS.privacyPolicy
  },
  {
    name: 'Cookies',
    url: URLS.cookiePolicy
  },
  {
    name: 'Sitemap',
    url: URLS.sitemap
  }
];
